<template lang="pug">
.pa-2
  v-dialog(
    v-model='showModalFormEvent'
    transition='dialog-top-transition',
    :width="isMovil ? '100%' : '450'",
    :fullscreen="isMovil"
    :hide-overlay="isMovil"
  )
    form-cita(:id="idCita", v-if="showModalFormEvent" @close="closeModalEventSelected()" @update="getEvents")
  v-card.mx-auto.elevation-1
    .d-flex(:class="{'fd-column' : isMovil}")
      .flex-1
        v-card-title.pa-3.pl-4
          span.font-weight-700(:class="{'font-size-17' : isMovil}") Programación de citas
        v-card-subtitle.pb-3.font-size-13 Crea, edita y elimina algunas citas
      v-divider(v-if="isMovil")
      v-card.d-flex.elevation-0.ai-center(:class="{'ma-2' : !isMovil}")
        v-btn.ma-1(fab small color="primary" @click='$refs.calendar.prev()')
          v-icon chevron_left
        v-select.ma-1(v-model='type' :items='types' item-text="label"  item-value="value" dense=''   solo hide-details='' label='Visualizar por')
        v-btn.ma-1(fab small color="primary" @click='$refs.calendar.next()')
          v-icon chevron_right
        v-btn.ma-1( color="success" small fab='' @click="showEvent()")
          v-icon add
        v-btn.ma-1( color="info" small fab='' @click="getEvents()")
          v-icon sync
    v-sheet(:height="isMovil ? 'calc(100vh - 183px)' : 'calc(100vh - 133px)'")
      //- :first-interval="23"
      v-calendar(
        ref='calendar'
        :event-ripple='false'
        :first-time="horaInicioDeIntervalo"
        :interval-count="countIntervals"
        v-model='value'
        color='primary'
        :type='type'
        :interval-minutes="intervaloProgramacionCitas"
        :events='events'
        @change='getEvents'
        :short-weekdays="isMovil"
        @click:event="showEvent"
        :weekdays="weekday"
        @click:date="showDay"
        :interval-format="intervalFormatter"
        :interval-height="isMovil ? 40 : 27",
        :event-color="checkBGColorEvent",
        :event-text-color="checkColorEvent",
      )
        template(v-slot:event='{ event, timed, eventSummary }')
          .v-event-draggable.animated.fadeInUp.faster.my-event(dark width="100%")
            //- .d-flex.fd-center.ai-center(:class="isMovil && type !== 'day' ? 'fd-column' : ''")
            //-   v-tooltip(bottom='')
            //-     template(v-slot:activator='{ on, attrs }')
            //-     small.font-size-11 Ver detalles de ticket {{event.numeroTicket}}
            v-chip.px-2.mx-1(:color="event.ingresadoAtaller ? 'success white--text' : 'orange white--text'" :dark="event.ingresadoAtaller ? true : false"  x-small  :to="!isMovil ?  `/ticket/${event.numeroTicket}` : ''")
              v-icon(:size="isMovil ? 2 : 6", :color="event.ingresadoAtaller ? 'white' : ''") circle
              span(:class="{'white--text' : event.ingresadoAtaller, 'font-size-10' : isMovil, 'font-weight-700' : !isMovil}") &nbsp;{{`${event.numeroTicket}`}}
            span(:class="isMovil ? 'font-size-10' : ' font-size-11 font-weight-700'") &nbsp;{{event.name && event.name.split(' - ')[0]}}&nbsp;
            v-spacer(v-if="!isMovil")
              //- span.font-size-10.font-weight-700(v-if="!isMovil", :color="event.ingresadoAtaller ? 'white--text' : 'info--text'") {{event.start | hora}} - {{event.end | hora}}
          //- .v-event-drag-bottom(v-if='timed') {{timed}}
</template>
<script>
  import formCita  from '@/components/c_card_form_programacion_cita'
  import moment from 'moment'
  import { apiGet, notify } from '../util/general'
  export default {
    components : {
      'form-cita' : formCita
    },
    props : {
      id : {
        type   : String,
        default: ''
      }
    },
    data () {
      return {
        type : 'week',
        types: [
          {
            label: 'Dia',
            value: 'day'
          },
          {
            label: 'Semana',
            value: 'week'
          }
        ],
        weekday                        : [1, 2, 3, 4, 5],
        value                          : '',
        events                         : [],
        showModalFormEvent             : false,
        idCita                         : 0,
        countIntervals                 : 0,
        countHorasParaCalcularIntervalo: 13,                // horas de trabajo
        horaInicioDeIntervalo          : '08:30',
        intervaloProgramacionCitas     : 15
      }
    },
    created () {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo parametros para agenda' })
      vm.fetchGetDataParametros((err, parametros) => {
        if (err) {
          notify(vm, 'error', 'Error', err.message)
          vm.$store.dispatch('transaccion', { isProceso : false })
        } else {
          vm.intervaloProgramacionCitas = parametros.intervaloProgramacionCitas
          vm.$store.dispatch('transaccion', { isProceso : false })
        }
        vm.calculateIntervalCount()
      })
    },
    computed : {
      isMovil () {
        var vm = this
        return vm.$vuetify.breakpoint.smAndDown
      }
    },
    mounted () {
      var vm = this
      if (vm.id) {
        vm.idCita = +vm.id
        vm.showModalFormEvent = true
      }
    },
    filters : {
      hora : function (val) {
        return moment(val, 'YYYY-MM-DD HH:mm').format('HH:mm')
      }
    },
    methods: {
      checkBGColorEvent (item) {
        console.log(item)
        return !item.ingresadoAtaller ?  '' : ''
      },
      checkColorEvent (item) {
        console.log(item)
        return !item.ingresadoAtaller ?  'grey--text' : 'dark--text'
      },
      fetchGetDataParametros (callback) {
        var vm = this
        var obj      = {}
        apiGet(vm, '/parametro/obtener', obj, function (data) {
          callback(null, data.lista[0])
        }, function (error) {
          callback(error)
        })
      },
      calculateIntervalCount () {
        var vm = this
        if (vm.intervaloProgramacionCitas) {
          var cantidad = vm.countHorasParaCalcularIntervalo * 60
          vm.countIntervals = cantidad / vm.intervaloProgramacionCitas
        }
      },
      intervalFormatter (locale, getOptions) {
        // return `${locale.time} ${locale.hour <= 12 ? 'AM' : 'PM'}`;
        return `${locale.time}`;
      },
      showDay (details) {
        var vm = this
        vm.type = 'day'
        vm.value = details.date
      },
      showEvent (data) {
        var vm = this
        if (data) {
          vm.idCita = data.event ? data.event.id : 0
        } else vm.idCita = 0
        vm.showModalFormEvent = true
      },
      getEvents (date) {
        var vm  = this
        var obj = {}
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo citas programadas' })
        apiGet(vm, '/cita/obtener', obj, function (data) {
          var lista = data.lista
          vm.events = []
          for (var i = 0; i < lista.length; i++) {
            var c   = lista[i];
            var obj = {
              id              : c.id,
              name            : c.titulo,
              start           : moment(c.fechaDesde).format('YYYY-MM-DD HH:mm'),
              end             : moment(c.fechaHasta).format('YYYY-MM-DD HH:mm'),
              numeroTicket    : c.numeroTicket,
              ingresadoAtaller: c.ingresadoAtaller
            }
            vm.events.push(obj)
          }
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, () => {
          vm.$store.dispatch('transaccion', { isProceso : false })
        })
      },
      closeModalEventSelected () {
        var vm = this
        vm.showModalFormEvent = false
      }
    }
  }
</script>
<style  lang="stylus">
.my-event {
  overflow     : hidden;
  text-overflow: ellipsis;
  white-space  : nowrap;
  border-radius: 2px;
  font-size    : 12px;
  // padding      : 4px;
  display      : 'flex';
  align-items  : 'center';
  justify-content: 'center';
  cursor       : pointer;
  // margin-bottom: 1px;
  left         : 1px;
  margin-right : 8px;
  position     : relative;
}

.theme--light.v-calendar-events .v-event-timed {

}

.v-calendar-daily__interval-text {
  top: -10px;
}

.v-event-draggable {
  // padding-left: 6px;
}

div .v-calendar .v-event-timed-container {
  margin-right: 0px !important
}

.v-event-timed {
  user-select        : none;
  -webkit-user-select: none
}

div .theme--light.v-calendar-events .v-event-timed {
  border-left: 0px solid #00d370 !important;
  border-right: 0px !important;
  border-top: 0px !important;
  border-bottom: 0px !important;
  display: flex;
  align-items: center;
}

.v-calendar .v-event-timed {
  border-radius: 0px !important;
}
.v-calendar .v-event-timed:hover {
  background:  #ebeff3
}

</style>



// WEBPACK FOOTER //
// View_programacion_de_citas.vue?1cb24e3a